<template>
    <div>
        <b-dropdown ref="dropdown" size="sm" id="dropdown-notificaciones" dropleft no-caret no-flip class="notifications">
            <template #button-content>
                <i style="font-size: 20px;" class="fas fa-bell"></i>
                <div class="notifications-menu" v-if="notificaciones && notificaciones.length > 0">
                    <b-badge>{{ notificaciones.length }}</b-badge>
                </div>
            </template>
            <b-dropdown-header class="text-center border-bottom">Nuevas notificaciones: <span class="red">{{ notificaciones.length }}</span></b-dropdown-header>
            <div v-if="notificaciones && notificaciones.length > 0">
                <template v-for="notificacion in notificaciones">
                    <div :key="notificacion.id" class="d-flex align-items-center p-2">
                        <i class="fas fa-bell mr-2" style="cursor: pointer;" @click="marcarComoLeida(notificacion)"></i>
                        <div style="width: 300px;">
                            <b-dropdown-text v-html="notificacion.data.mensaje"></b-dropdown-text>
                            <span class="red" style="font-size: 13px;">{{ notificacion.created_at }}</span>
                        </div>
                    </div>
                </template>
                <div class="border-top pt-2 text-center">
                    <span style="color: rgb(108, 117, 125)" role="button" @click="marcarComoLeidas()">MARCAR COMO LEIDAS</span>
                </div>
            </div>
            <b-dropdown-text v-else class="p-2">No tienes notificaciones.</b-dropdown-text>
        </b-dropdown>
    </div>
</template>

<script>
export default {
    data() {
        return {
            notificaciones: []
        }
    },
    computed: {
        user() {
            return this.$store.getters.getUser;
        }
    },
    created() {
        this.getNotificaciones();
    },
    mounted() {
        if (this.user && this.user.id) {
            this.$echo.channel('manager.user.' + this.user.id).on('new.notification', e => {
                this.notificaciones.push(e);
            });
        }
    },
    methods: {
        getNotificaciones(){
            let params = {
                filters: {}
            }
            this.$store.dispatch(this.config.getVuexAlias('back.notificaciones.get'), params).then(res => {
                this.notificaciones = res.data.data;
            });
        },
        marcarComoLeida(notificacion) {
            let params = {
                filters: {},
                notificacion_id: notificacion.id
            }
            this.$store.dispatch(this.config.getVuexAlias('back.notificaciones.marcar-como-leida'), params).then(res => {
                this.getNotificaciones();
                if (this.notificaciones == []) {
                    this.$refs.dropdown.hide();    
                }
                this.$toast.success('Notificación leída correctamente')
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        },
        marcarComoLeidas(){
            let params = {
                filters: {}
            }
            this.$store.dispatch(this.config.getVuexAlias('back.notificaciones.marcar-como-leidas'), params).then(res => {
                this.notificaciones = [];
                this.$refs.dropdown.hide();
                this.$toast.success('Notificaciónes leídas correctamente')
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        }
    }
}
</script>

<style>
    .notifications-menu {
        font-size: 18px;
        position: absolute;
        bottom: 50%;
        right: .1%
    }

    .notifications .dropdown-menu {
        max-height: 80vh;
        overflow-y: auto;
    }

    #dropdown-notificaciones__BV_toggle_ {
        background-color: transparent !important;
        border: none !important;
        width: 50px;
    }
</style>